<template>
  <div id="app">
    <transition name="fade" mode="out-in" @before-enter="beforeEnter" @enter="enter" @after-leave="afterLeave" appear>
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      savedPosition: null,
      isTransitioning: false
    };
  },
  methods: {
    beforeEnter(el) {
      this.isTransitioning = true;
    },
    enter(el, done) {
      // If going to project page, scroll to top after fade in starts
      if (this.$route.name === 'Project') {
        setTimeout(() => {
          window.scrollTo(0, 0);
          done();
        }, 100); // Shorter delay since fade-in is starting
      } else {
        done();
      }
    },
    afterLeave() {
      this.isTransitioning = false;
      // If returning to home and we have a saved position, restore it
      if (this.$route.name === 'Home' && this.savedPosition) {
        setTimeout(() => {
          window.scrollTo(this.savedPosition.x, this.savedPosition.y);
          this.savedPosition = null;
        }, 50);
      }
    }
  },
  watch: {
    $route(to, from) {
      // Save position when leaving home page for project
      if (from.name === 'Home' && to.name === 'Project') {
        this.savedPosition = { x: window.pageXOffset, y: window.pageYOffset };
      }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Ensure smooth transition by preventing layout shifts */
.fade-enter-active {
  transition-delay: 0.1s; /* Small delay to ensure content is ready */
}
</style>